import {useEffect,useRef} from 'react';
import {useInRouterContext,useLocation} from 'react-router-dom';
import {trackPageView} from '../utils/analytics';

const TITLE_TIMEOUT_MS=3000;

// Sends one page_view per navigation after the document title updates.
function AnalyticsPageViewsContent() {
  const {pathname,search}=useLocation();
  const lastTitle=useRef(null);

  useEffect(()=> {
    if (pathname.startsWith('/admin')) return undefined;

    let sent=false;
    let observer=null;
    let frameId=null;

    const send=()=> {
      if (sent) return;
      sent=true;
      if (observer) observer.disconnect();
      clearTimeout(timeoutId);
      lastTitle.current=document.title;
      trackPageView({
        path: pathname + search,
        title: document.title,
        location: window.location.href
      });
    };

    const sendIfTitleChanged=()=> {
      if (document.title !==lastTitle.current) {
        send();
        return true;
      }
      return false;
    };

    const timeoutId=setTimeout(send,TITLE_TIMEOUT_MS);
    frameId=requestAnimationFrame(()=> {
      frameId=requestAnimationFrame(()=> {
        if (sendIfTitleChanged()) return;
        observer=new MutationObserver(sendIfTitleChanged);
        observer.observe(document.head,{
          subtree: true,
          childList: true,
          characterData: true
        });
      });
    });

    return ()=> {
      sent=true;
      cancelAnimationFrame(frameId);
      clearTimeout(timeoutId);
      if (observer) observer.disconnect();
    };
  },[pathname,search]);

  return null;
}

export default function AnalyticsPageViews() {
  const inRouter=useInRouterContext();
  return inRouter ? <AnalyticsPageViewsContent /> : null;
}